import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { REACT_APP_CLERK_PUBLISHABLE_KEY } from '../../constants/config';

const ClerkWrapper = ({ children }) => {
    return <ClerkProvider publishableKey={REACT_APP_CLERK_PUBLISHABLE_KEY}>{children}</ClerkProvider>;
};

export default ClerkWrapper;
